import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Copy, Eye } from 'lucide-react';
import Modal from './Modal';
import { toast } from '../utils/toast';

export default function InviteModal({ sessionId, onClose }) {
  const [qr, setQr] = useState(null);
  const baseUrl = `${window.location.origin}${window.location.pathname}`;
  const joinUrl = `${baseUrl}?session=${encodeURIComponent(sessionId)}`;
  const spectateUrl = `${joinUrl}&spectate=1`;

  useEffect(() => {
    QRCode.toDataURL(joinUrl, { width: 480, margin: 1, color: { dark: '#1e293b' } })
      .then(setQr)
      .catch(() => setQr(null));
  }, [joinUrl]);

  const copy = (text, label) => {
    navigator.clipboard.writeText(text)
      .then(() => toast(`${label} copied to clipboard.`, 'success'))
      .catch(() => toast('Copy failed, select and copy the link manually.'));
  };

  return (
    <Modal title={`Invite to "${sessionId}"`} onClose={onClose}>
      <div className="text-center">
        {qr && (
          <img
            src={qr}
            alt={`QR code to join session ${sessionId}`}
            className="w-52 h-52 mx-auto rounded-card border border-line"
          />
        )}
        <p className="text-meta text-ink-2 mt-2">Project this, students scan to join instantly.</p>
      </div>

      <div className="mt-5 space-y-3">
        <div>
          <label className="text-meta font-medium text-ink-2 mb-1 block">Join link</label>
          <div className="flex gap-2">
            <input readOnly value={joinUrl} className="flex-1 px-3 py-2 border border-line rounded-ctl text-meta text-ink bg-page outline-none" onFocus={(e) => e.target.select()} />
            <button onClick={() => copy(joinUrl, 'Join link')} className="px-3 py-2 bg-accent text-white rounded-ctl hover:bg-accent-strong transition" aria-label="Copy join link">
              <Copy className="w-4 h-4" />
            </button>
          </div>
        </div>
        <div>
          <label className="text-meta font-medium text-ink-2 mb-1 flex items-center gap-1">
            <Eye className="w-3 h-3" />Read-only link <span className="text-ink-2 font-normal">: for observers or post-session review</span>
          </label>
          <div className="flex gap-2">
            <input readOnly value={spectateUrl} className="flex-1 px-3 py-2 border border-line rounded-ctl text-meta text-ink bg-page outline-none" onFocus={(e) => e.target.select()} />
            <button onClick={() => copy(spectateUrl, 'Read-only link')} className="px-3 py-2 bg-ink-2 text-white rounded-ctl hover:bg-ink transition" aria-label="Copy read-only link">
              <Copy className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
